import { ArrowRight } from "lucide-react";

// HP4 draft — "Expert skincare guidance": light-blue copy panel + specialist image.
const WOMAN = "https://images.unsplash.com/photo-1655026392641-bf283a5f12d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const ExpertGuidanceV4 = () => (
  <section className="bg-white py-12 lg:py-16" data-testid="hp4-expert-guidance">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 rounded-sm overflow-hidden">
        <div className="bg-[#D8E7EA] px-8 lg:px-14 py-12 lg:py-16 flex flex-col justify-center">
          <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-riversol-blue mb-4">How it works</div>
          <h2 className="text-[28px] sm:text-[34px] lg:text-[42px] leading-[1.05] tracking-[-0.02em] text-neutral-900">
            Expert skincare guidance.
          </h2>
          <p className="mt-5 text-[15px] lg:text-[16px] leading-relaxed text-neutral-700 max-w-[30rem]">
            Discover your ideal routine with a personalized consultation from our experts. We'll recommend products tailored to your skin type, concerns and goals — whether you're addressing sun damage, enhancing your glow, or building a foundational regimen. Our team is here to guide you toward radiant, healthy skin.
          </p>
          <a
            href="https://www.riversol.com/pages/skin-analyzer"
            data-testid="hp4-expert-cta"
            className="group mt-8 inline-flex items-center gap-2 self-start bg-riversol-blue text-white rounded-full px-7 py-3.5 text-[12px] tracking-[0.16em] uppercase font-medium hover:bg-riversol-blueLight transition-colors"
          >
            Meet with a specialist
            <ArrowRight size={15} strokeWidth={1.8} className="transition-transform group-hover:translate-x-0.5" />
          </a>
        </div>
        <div className="relative min-h-[360px] lg:min-h-0 bg-neutral-100">
          <img src={WOMAN} alt="Riversol skincare specialist consultation" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        </div>
      </div>
    </div>
  </section>
);

export default ExpertGuidanceV4;
